import * as React from 'react';
export const personWithKeySvg = React.forwardRef(function personWithKeySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-1.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm5.75 1a2.25 2.25 0 0 0-.75 4.372v3.378a.75.75 0 0 0 1.5 0V15h.75a.75.75 0 0 0 0-1.5h-.75v-1.628a2.251 2.251 0 0 0-.75-4.372ZM13 9.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M.5 14a5 5 0 0 1 5-5h3.75a.75.75 0 0 1 0 1.5H5.5A3.5 3.5 0 0 0 2 14a.5.5 0 0 0 .5.5h8.25a.75.75 0 0 1 0 1.5H2.5a2 2 0 0 1-2-2Z',
    }),
  );
});
personWithKeySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var personWithKey = {
  category: 'icon',
  colorable: true,
  name: 'personWithKey',
  svg: personWithKeySvg,
};
